import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      if (JSON.parse(currentUser)['first_login'] === false) {
        return true;
      } else {
        if (JSON.parse(currentUser)['first_login'] === undefined){
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
          return false;
        } else {
          this.router.navigate(['/first-login'], { queryParams: { returnUrl: state.url } });
          return false;
        }
      }
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

}
